<template>
	<Col class="width-100 height-100 carousel-container">
		<Carousel :documents="documents" />
	</Col>
</template>

<script>
import { applyReactInVue } from 'vuereact-combined';
import Carousel from '@/react_app/components/Carousel.jsx';
export default {
	name: 'DocumentsViewer',
	components: {
		Carousel: applyReactInVue(Carousel),
	},
	props: {
		documents: { type: Array }, // {title: String, src: String}
	},
};
</script>
<style scoped lang="scss">
.carousel-container {
	overflow: hidden;
	max-width: 52vh;
}
::v-deep {
	.carousel .thumbs {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
}
</style>
